import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CtBatch } from '@ps-gui/claims-terminal-shared';
import { ApiService } from '@ps-gui/shared-core';
import { DocumentExtractionResults, mapExtractedData } from './extracted-data-mapper';
import { CompleteEingangCt2Dto, Ct2CompletionResponseDto } from '../../models/interfaces';

@Injectable({
  providedIn: 'root',
})
export class CtBatchExtractionApiService extends ApiService {
  protected override get baseUrl(): string {
    return this.backendUrls.ctBackendUrl;
  }

  protected override get baseUrlSuffix(): string {
    return '/api/batch';
  }

  signalCtBatchCt2Completion(batchId: string): Observable<void> {
    return this.post(`${batchId}/ct2/completed`);
  }

  completeEingangCt2(
    batchId: string,
    dto: CompleteEingangCt2Dto,
  ): Observable<Ct2CompletionResponseDto> {
    return this.post<Ct2CompletionResponseDto, CompleteEingangCt2Dto>(
      `${batchId}/eingang/ct2/completed`,
      dto,
    );
  }

  completeEingangCt2WithForwarding(
    batchId: string,
    dto: CompleteEingangCt2Dto,
  ): Observable<Ct2CompletionResponseDto> {
    return this.put<Ct2CompletionResponseDto, CompleteEingangCt2Dto>(
      `${batchId}/eingang/ct2/completed-with-forwarding`,
      dto,
    );
  }

  loadExtractionDataByDocumentId(ctBatch: CtBatch): Observable<DocumentExtractionResults> {
    return this.get<DocumentExtractionResults>(`${ctBatch.id}/extracted-data`).pipe(
      map((data: DocumentExtractionResults) => mapExtractedData(data)),
    );
  }
}
